module.exports = [function () {
  'use strict';

  this.set = function (newConfig) {
    this.config = newConfig;
  };

  this.$get = function () {
    return this;
  };
}];


// WEBPACK FOOTER //
// ./node_modules/@kathondvla/sri-client/ng-sri-client/sri-client-configuration.js